//items-center justify-center
//py-2
//px-20

import { useEffect, useState } from 'react';
import {useDispatch,useSelector} from 'react-redux'
import { login } from '../state/apiCalls';
import { useNavigate,useLocation, Link } from 'react-router-dom';
import Loader from '../Modals/Loader';
import { useRef } from 'react';
import Alert from '../Modals/Alert';

function Login() {
  //Get the user state in the global store
  const {currentUser} = useSelector((state)=>state.user);
  const location =  useLocation();
  const loaderRef = useRef()
  const alertRef = useRef()
  const [alertMessage,setAlertMessage] = useState(null)
  //get the requested url
  const requestedURL = location.state == null? null: location.state.requestedURL

  const [username,setUsername] = useState("");
  const [password,setPassword] = useState("");
  const dispatch = useDispatch();
  const {isFetching,error} = useSelector((state)=>state.user);
  const navigate = useNavigate()
  //Login function
  useEffect(()=>{
    //if already logged in, reroute to home page
    
    if(currentUser!=null){
      
        navigate("/adminhome")
      }
  },[])


  const handleClick = (e)=>{
    e.preventDefault()

    try {
      
      if(username.trim().length === 0 ){
        setAlertMessage('Username cannot be empty')
        alertRef.current.toggleState()
        return

      } else {
        if(password.trim().length === 0){
          setAlertMessage('Password cannot be empty')
          alertRef.current.toggleState()
          return
        }
      }

      loaderRef.current.toggleState()
      login(dispatch,loaderRef,alertRef,setAlertMessage,{username:username,password},navigate,requestedURL)

    } catch (e){
        console.log(e)
    }
    
  }
  return (
    <>
      {/*Bigger screens*/}
      <div className="hidden md:flex flex-col w-full items-center justify-center text-center min-h-screen bg-gradient-to-tr from-[#100A33] via-[#101142] to-[#111B59] py-2 px-20">
      <div className="bg-white rounded-2xl shadow-2xl flex w-2/3 max-w-4xl">
        <div className="w-3/5 p-5">
          <div className="text-left font-bold">
          </div>
          <div className="py-10">
            <h2 className="font-bold text-3xl mb-6">Sign in</h2>
            <div className="flex justify-center my-2">
            </div>
            <div className="flex flex-col md:items-center">
              <div className="bg-gray-100 w-64 flex items-center mb-3">
                <input type="user" name="email" placeholder="Username" 
                className="bg-gray-100 border py-2.5 px-3 border-gray-300 outline-none flex-1 text-sm focus:outline-none focus:border-black focus:ring-1 focus:ring-black" 
                onChange={(e)=>{setUsername(e.target.value)}}></input>
              </div>
              <div className="bg-gray-100 w-64  flex items-center mb-3">
                <input type="password" name="Password" placeholder="Password" 
                className="bg-gray-100 py-2.5 px-3 border border-gray-300 outline-none flex-1 text-sm focus:outline-none focus:border-black focus:ring-1 focus:ring-black" 
                onChange={(e)=>{setPassword(e.target.value)}}></input>
                
              </div>
              {/*error? <span className='text-red-400'>Something went wrong</span>:""*/}
              <div className="flex w-64 mb-5 justify-between">
                <label className="flex items-center text-xs"><input type="checkbox" className="mr-2"></input>Remember me</label>
                <Link to={`/reset`} className="text-xs hover:text-green-200">Forgot Password?</Link>
              </div>
              <a href="#" className="border-2 border-precision rounded-full px-12 py-2 inline-block font-semibold hover:bg-precision hover:text-white disabled:cursor-not-allowed" onClick={(e)=>{handleClick(e)}} disabled={isFetching}>Sign In</a>
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center w-2/5 bg-gradient-to-tr from-[#100A33] via-[#101142] to-[#111B59] text-white rounded-tr-2xl rounded-br-2xl py-36 px-12">
          <img className='w-[50px] h-[50px]' src='https://portifolio-images-chimwemwe.s3.us-east-1.amazonaws.com/logo_terravirt-removebg-preview.png'></img>
          <h3 className="text-3xl font-bold mb-2">Vectors4D</h3>
          <div className="border-2 w-40 border-white inline-block"></div>
          
        </div>
      </div>
    </div>
    {/*small screens*/}
    <div className="md:hidden flex flex-col w-[100%] self-center items-center justify-center text-center min-h-screen bg-gradient-to-tr from-[#100A33] via-[#101142] to-[#111B59] py-2 ">
      <div className="w-[100%] ">
        <div className="w-[100%] p-5 ">
          <div className="text-left font-bold "></div>
          <div className="py-10 flex flex-col items-center justify-center shadow-2xl bg-gray-100 rounded-2xl">
            <h2 className="text-sm mb-6 font-bold">Vectors4D</h2>
            <img className='w-[40px] h-[40px]' src='https://portifolio-images-chimwemwe.s3.us-east-1.amazonaws.com/logo_terravirt-removebg-preview.png'></img>
            <h2 className="text-sm mb-6">Sign in</h2>
            <div className="flex justify-center my-2"></div>
            <div className="flex flex-col items-center justify-center">
              <div className="bg-gray-100 w-[100%] flex items-center mb-3">
                <input type="user" name="email" placeholder="Username" 
                className="bg-gray-100 border py-2.5 px-3 border-gray-300 outline-none flex-1 text-sm focus:outline-none focus:border-black focus:ring-1 focus:ring-black" 
                onChange={(e)=>{setUsername(e.target.value)}}></input>
              </div>
              <div className="bg-gray-100 w-[100%]  flex items-center mb-3">
                <input type="password" name="Password" placeholder="Password" 
                className="bg-gray-100 py-2.5 px-3 border border-gray-300 outline-none flex-1 text-sm focus:outline-none focus:border-black focus:ring-1 focus:ring-black" 
                onChange={(e)=>{setPassword(e.target.value)}}></input>
                
              </div>
              {/*error? <span className='text-red-400'>Something went wrong</span>:""*/}
              <div className="flex w-[100%] mb-5 justify-between">
                <Link to={`/#`} className="text-xs hover:text-green-200">Forgot Password?</Link>
              </div>
              <a href="#" className="border-2 border-precision rounded-full px-12 py-2 inline-block font-semibold hover:bg-precision hover:text-white disabled:cursor-not-allowed" onClick={(e)=>{handleClick(e)}} disabled={isFetching}>Sign In</a>
            </div>
          </div>
        </div>
        {/*
        <div className="w-2/5 bg-[#1C1C1C] text-white rounded-tr-2xl rounded-br-2xl py-36 px-12">
          <h3 className="text-3xl font-bold mb-2">Propel Health</h3>
          <div className="border-2 w-40 border-white inline-block"></div>
          
        </div>*/}
      </div>
    </div>
    <Loader ref={loaderRef}/>
    <Alert ref={alertRef} message={alertMessage}/>
    </>
    
  );
}

export default Login;
//items-center justify-center
//py-2
//px-20

